module.exports = {"id":"dp3_3l3q1","text":"Copyright and licences","instructions":"Which best defines intellectual property in digital contexts?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l3q1-a1","text":"Legal rights over creations","score":3.7},{"id":"dp3_3l3q1-a2","text":"Ownership of devices","score":1.3},{"id":"dp3_3l3q1-a3","text":"Control of online access","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l3q1.json
// module id = 1160
// module chunks = 41